export default {
  computed: {
    $guid() {
      return this.$route.params.guid
        ? this.$route.params.guid
        : this.$store.state.auth.employeeID
        ? this.$store.state.auth.employeeID
        : ''
    },

    $guid_self() {
      return this.$store.state.auth.employeeID
        ? this.$store.state.auth.employeeID
        : ''
    },

    $guid_target() {
      return this.$isSelf
        ? this.$store.state.auth.employeeID
        : this.$route.params.guid
        ? this.$route.params.guid
        : ''
    },

    $isSelf() {
      const excludes = ['LeaveApproveTimeline']
      return (
        this.$route.path.startsWith('/manage/leave') ||
        excludes.includes(this.$route.name) ||
        this.$guid.toUpperCase() === this.$guid_self.toUpperCase()
      )
    },

    $username() {
      const auth = this.$store.state.auth
      const firstNameTha = auth.firstNameTha || ''
      const middleNameTha = auth.middleNameTha || ''
      const lastNameTha = auth.lastNameTha || ''

      return firstNameTha + ' ' + middleNameTha + ' ' + lastNameTha
    },

    $useremail() {
      return this.$store.state.auth.emailCMU
        ? this.$store.state.auth.emailCMU
        : ''
    },

    $positionName() {
      return this.$store.state.auth.positionName
        ? this.$store.state.auth.positionName
        : ''
    },

    $orgName() {
      return this.$store.state.auth.orgName
        ? this.$store.state.auth.orgName
        : 'Unknown org name'
    },

    $userProfilePicPath() {
      let res = { type: 'icon', src: 'Na', color: 'primary lighten-1' }
      const picEmpPath = this.$store.state.auth.picEmpPath
      if (picEmpPath) {
        res = {
          type: 'img',
          src: picEmpPath,
          color: 'primary lighten-4'
        }
      } else {
        let acronym = ''
        const firstNameEng = this.$store.state.auth.firstNameEng
        const lastNameEng = this.$store.state.auth.lastNameEng
        if (firstNameEng && lastNameEng) {
          acronym = firstNameEng.substr(0, 1) + lastNameEng.substr(0, 1)
        } else if (firstNameEng) {
          acronym = firstNameEng.substr(0, 2)
        } else if (lastNameEng) {
          acronym = lastNameEng.substr(0, 2)
        } else {
          acronym = 'Na'
        }
        res = { type: 'icon', src: acronym, color: 'primary lighten-1' }
      }

      return res
    }
  }
}
